namespace advisorop.services {

    // The in-app AI assistant's calls. Advisors and servicers only; the API enforces it.
    export class AiChatService {

        readonly apiUrl = "api/aichat";

        static $inject = ["$http"];
        constructor(private $http: ng.IHttpService) {
        }

        getStatus(): ng.IHttpPromise<domains.IAiChatStatus> {
            return this.$http.get(`${this.apiUrl}/status`);
        }

        // The conversation asked for, or the current sign-in's when there is none (or it is not this person's).
        getConversation(sessionId?: number): ng.IHttpPromise<domains.IAiChatConversation> {
            return this.$http.get(`${this.apiUrl}/conversation`, { params: { sessionId: sessionId } });
        }

        listConversations(): ng.IHttpPromise<domains.IAiChatConversationSummary[]> {
            return this.$http.get(`${this.apiUrl}/conversations`);
        }

        newConversation(): ng.IHttpPromise<domains.IAiChatConversation> {
            return this.$http.post(`${this.apiUrl}/new`, {});
        }

        // requestId names the question for stop(); resolving dropRequest drops the request in the browser.
        ask(question: string, pagePath: string, sessionId: number, requestId: string,
            dropRequest: ng.IPromise<any>): ng.IHttpPromise<domains.IAiChatReply> {
            return this.$http.post(`${this.apiUrl}/ask`,
                { question: question, pagePath: pagePath, sessionId: sessionId, requestId: requestId },
                { timeout: dropRequest });
        }

        // Stops the question on the server too: whether it notices a dropped request depends on the hosting.
        stop(requestId: string): ng.IHttpPromise<any> {
            return this.$http.post(`${this.apiUrl}/stop`, { requestId: requestId });
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("aiChatService", AiChatService);
}
